import { useRecoilState } from "recoil";
import { useBaseParam } from "../hooks/useBaseParam";

import * as Atom from '../recoil/index';
import { fetchHousePreList } from "../../infra/api/mtg/fetchHousePreList";
import { useEffect, useState } from "react";
import { HOME_BANNER_MTG } from "../staticData/Banner/HOME_BANNER";
import { fetchHouseReqList } from "../../infra/api/mtg/fetchHouseReqList";
import moment from "moment";

const useMtgLanding = () => {
    const [personal] = useRecoilState(Atom.personalInfo);
    const fetchPreList = useBaseParam(fetchHousePreList, {custSeq: personal.custSeq}, {noToast: true});
    const fetchReqList = useBaseParam(fetchHouseReqList, {custSeq: personal.custSeq}, {noToast: true});

    const [hasPreRequest, setHasPreRequest] = useState<boolean>(false);
    const [hasRequest, setHasRequest] = useState<boolean>(false);

    const [isLoading, setLoading] = useState<boolean>(false);
    const [simpleList, setSimpleList] = useState<any[]>([]);

    const getPreList = async () => {
        const prePromise = fetchPreList();
        const reqPromise = fetchReqList();
        const [res, reqRes] = await Promise.all([prePromise, reqPromise]);
        const housePreList = res.data.result;
        if (housePreList && housePreList.housePreRequestInfoData?.regDate) {
            const today = moment().format("YYYY-MM-DD");
            const tomorrow = moment().add(1, 'days').format("YYYY-MM-DD");
            // if (today === (housePreList.housePreRequestInfoData.regDate as string).substring(0, 10) || (housePreList.allProductItemList && housePreList.allProductItemList.length > 0) ) {
            // OTDK-1689 오늘, 내일까지만 가심사 결과 노출
            if (today === (housePreList.housePreRequestInfoData.regDate as string).substring(0, 10) || tomorrow === (housePreList.housePreRequestInfoData.regDate as string).substring(0, 10)) {
                setHasPreRequest(true);
            }
        }

        if (reqRes.data.result && reqRes.data.result.length > 0) {
            setHasRequest(true);
            setSimpleList(HOME_BANNER_MTG);
        } else {
            setSimpleList(HOME_BANNER_MTG.filter(item => item.headerText !== '대출 신청내역'));
        }

        setLoading(true);
    }

    useEffect(() => {
        getPreList();
    }, []);

    return {
        isLoading,
        simpleList,
        hasPreRequest,
        hasRequest,
    }
}

export default useMtgLanding;